import React from 'react';
import { Link } from 'react-router-dom';
import {
  PopoverContainer,
  PopoverContent,
  PopoverArrow,
  CategoryGrid,
  CategoryItem,
  CategoryImage,
  CategoryName,
} from './ProductsPopover.styled';
import { CATEGORIES } from '../Categories/constant';

const ProductsPopover = ({
  isVisible,
  onMouseEnter,
  onMouseLeave,
  arrowPosition,
}) => {
  return (
    <PopoverContainer
      initial={{ opacity: 0, y: -10 }}
      animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: -10 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.2 }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <PopoverContent data-popover-content>
        <PopoverArrow style={{ left: `${arrowPosition}px` }} />
        <CategoryGrid>
          {CATEGORIES.map((category) => (
            <CategoryItem
              key={category.slug}
              as={Link}
              to={`/products/${category.slug}`}
            >
              <CategoryImage
                src={category.image}
                alt={category.name}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <CategoryName>{category.name}</CategoryName>
            </CategoryItem>
          ))}
        </CategoryGrid>
      </PopoverContent>
    </PopoverContainer>
  );
};

export default ProductsPopover;
